// src/axios/services/balneario.js
import BaseService from "./baseService";

const balnearioService = new BaseService("balneario");

export default balnearioService;
